import React from "react";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import CustomAuthRoute from "./CustomAuthRoute";
import CustomAdminRoute from "./CustomAdminRoute";
import CustomPublicRoute from "./CustomPublicroute";
import { Routes } from "./constants";
import {
  Login,
  Register,
  Dashboard,
  Error,
  ForgotPassword,
  Home,
  Booking,
  Subscription,
  ChangePassword,
  Contact,
  Faq,
  TermsAndCondition,
  PrivacyPolicy,
  ThankYou,
  BookingForm,
  ResetPassword,
  ProductSubscription,
  PatientForm,
  DeclineSubscription,
  PatientUpdatedForm,
  PatientList,
  DependentForm,
} from "./component";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashobardImages from "./component/dashboard/DashobardImages";
import WellbeingServices from "./component/dashboard/WellbeingServices";
import GPAppointments from "./component/dashboard/GPAppointments";
import BuySubscription from "./component/BuySubscription";
import StripeCheckout from "./component/StripeCheckout";

function App() {
  return (
    <React.Fragment>
      <ToastContainer />
      <Router>
        <Switch>
          <Route exact path={Routes.DEFAULT} component={Home} />
          <CustomAuthRoute exact path={Routes.LOGIN} component={Login} />
          {/* <CustomAuthRoute exact path={Routes.REGISTER} component={Register} /> */}
          {/* <Route
            exact
            path={Routes.REGISTER}
            render={() => <Redirect to={Routes.LOGIN} />}
          /> */}
          <Route
            exact
            path={Routes.REGISTER}
            render={(props) => {
              const params = new URLSearchParams(props.location.search);
              const uri = params.get("uri");

              const allowedUri =
                "$2y$10$MqFTXXDeYZBdj2xenMTUDuJLSPtgBLYgZi54Ql/SMB4FPAKO1XsfW";

              if (uri === allowedUri) {
                return <Register {...props} />;
              }

              return <Redirect to={Routes.LOGIN} />;
            }}
          />
          <CustomAuthRoute
            exact
            path={Routes.FORGOT_PASSWORD}
            component={ForgotPassword}
          />
          <CustomAuthRoute
            exact
            path={Routes.RESET_PASSWORD}
            component={ResetPassword}
          />
          <CustomPublicRoute exact path={Routes.CONTACT} component={Contact} />
          <CustomPublicRoute exact path={Routes.FAQ} component={Faq} />
          <CustomPublicRoute
            exact
            path={Routes.TERMSANDCONDITION}
            component={TermsAndCondition}
          />
          <CustomPublicRoute
            exact
            path={Routes.PRIVACYANDPOLICY}
            component={PrivacyPolicy}
          />
          <CustomPublicRoute
            exact
            path={Routes.THANKYOUPAGE}
            component={ThankYou}
          />
          <CustomPublicRoute
            exact
            path={Routes.FAILEDSUBSCRIPTION}
            component={DeclineSubscription}
          />
          <CustomPublicRoute
            exact
            path={Routes.SUBSCRIPTION}
            component={Subscription}
          />
          <CustomPublicRoute
            exact
            path={Routes.PRODUCTSUBSCRIPTION}
            component={ProductSubscription}
          />
          {/* <CustomPublicRoute
            exact
            path={Routes.BUY_SUBSCRIPTION}
            component={BuySubscription}
          /> */}
          <Route
            exact
            path={Routes.BUY_SUBSCRIPTION}
            render={() => <Redirect to={Routes.LOGIN} />}
          />

          <CustomPublicRoute
            exact
            path={Routes.STRIPE_CHECKOUT}
            component={StripeCheckout}
          />
          <CustomAdminRoute
            exact
            path={Routes.DASHBOARD}
            component={Dashboard}
          />
          <CustomAdminRoute
            exact
            path={Routes.CHANGEPASSWORD}
            component={ChangePassword}
          />
          <CustomAdminRoute
            exact
            path={Routes.BOOKINGFORM}
            component={BookingForm}
          />
          <CustomAdminRoute
            exact
            path={Routes.PATIENTLIST}
            component={PatientList}
          />
          <CustomAdminRoute
            exact
            path={Routes.PATIENTFORM}
            component={PatientForm}
          />
          <CustomAdminRoute
            exact
            path={Routes.DEPENDENTFORM + "/:pid"}
            component={DependentForm}
          />
          <CustomAdminRoute
            exact
            path={Routes.BOOKING + "/:pid" + "/:did"}
            component={Booking}
          />
          <CustomAdminRoute
            exact
            path={Routes.PATIENTUPDATEDFORM + "/:pid"}
            component={PatientUpdatedForm}
          />
          <CustomAdminRoute
            exact
            path={Routes.SERVICE_SELECTION}
            component={DashobardImages}
          />
          <CustomAdminRoute
            exact
            path={Routes.GP_APPOINTMENTS}
            component={GPAppointments}
          />
          <CustomAdminRoute
            exact
            path={Routes.WELLBEING_SERVICES}
            component={WellbeingServices}
          />
          <Route exact path={Routes.ERROR} component={Error} />
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default App;

// File Created By sourav on 01/05/2023
